import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "card" }
const _hoisted_2 = { class: "card-body" }
const _hoisted_3 = {
  class: "row",
  id: "wrap"
}
const _hoisted_4 = { class: "col-xxl-9 box-col-70" }
const _hoisted_5 = {
  class: "calendar-default",
  id: "calendar-container"
}
const _hoisted_6 = { id: "calendar" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FullCalendar = _resolveComponent("FullCalendar")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _cache[0] || (_cache[0] = _createStaticVNode("<div class=\"col-xxl-3 box-col-30\"><div id=\"external-events\"><h4>Draggable Events</h4><div id=\"external-events-list\"><div class=\"fc-event fc-h-event fc-daygrid-event fc-daygrid-block-event draggableButton\"><div class=\"fc-event-main\"><i class=\"fa fa-birthday-cake me-2\"></i>Birthday Party </div></div><div class=\"fc-event fc-h-event fc-daygrid-event fc-daygrid-block-event draggableButton\"><div class=\"fc-event-main\"><i class=\"fa fa-user me-2\"></i>Meeting With Team.</div></div><div class=\"fc-event fc-h-event fc-daygrid-event fc-daygrid-block-event draggableButton\"><div class=\"fc-event-main\"><i class=\"fa fa-plane me-2\"></i>Tour &amp; Picnic</div></div><div class=\"fc-event fc-h-event fc-daygrid-event fc-daygrid-block-event draggableButton\"><div class=\"fc-event-main\"><i class=\"fa fa-file-text me-2\"></i>Reporting Schedule </div></div><div class=\"fc-event fc-h-event fc-daygrid-event fc-daygrid-block-event draggableButton\"><div class=\"fc-event-main\"><i class=\"fa fa-briefcase me-2\"></i>Lunch &amp; Break</div></div></div><p><input class=\"checkbox_animated\" id=\"drop-remove\" type=\"checkbox\"><label for=\"drop-remove\">remove after drop</label></p></div></div>", 1)),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createVNode(_component_FullCalendar, {
                id: "calendar",
                options: $setup.calendarOptions
              }, null, 8 /* PROPS */, ["options"])
            ])
          ])
        ])
      ])
    ])
  ]))
}